// extracted by mini-css-extract-plugin
module.exports =  {"textarea":"_13c3691929--textarea--K7RuB","counter":"_13c3691929--counter--roeZQ"};